import axios from 'axios'
import TherapistApiManager from './managers/TherapistApiManager';

let BASE_URL = process.env.APP_URL + '/users';

export default new TherapistApiManager(axios, `${BASE_URL}/therapists`);




// WEBPACK FOOTER //
// ./src/modules/user/api/therapist.js